import { RPCDocs } from "../../../../../services/rpc.js";
import { FormikNumber } from "../../../../../components/FormikFields/FormikNumber.js";
import { FormikSelect } from "../../../../../components/FormikFields/FormikSelect.js";
import { FormikSelectRecordTag } from "../../FormikSelectRecordTag.js";
import { useRecordsFieldOptionsConfig } from "../../../../RecordsFieldOptionsConfig/context.js";
import { toOptions } from "../../../../RecordsFieldOptionsConfig/utils.js";
import { TbArrowBigRightFilled } from "react-icons/tb";
import "react";
import { Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { useFormikContext } from "formik";
//#region src/modules/Records/shared/RecordSearchFilters/components/VehicleFields.tsx
function VehicleFields() {
	const { values } = useFormikContext();
	const config = useRecordsFieldOptionsConfig();
	return /* @__PURE__ */ jsx("div", {
		className: "flex w-full flex-col",
		children: values.config.showAdvancedFilters && /* @__PURE__ */ jsxs("div", {
			className: "gap-xxs grid grid-cols-2 md:grid-cols-4",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: "col-span-2",
					children: /* @__PURE__ */ jsx(FormikSelectRecordTag, {
						typeFilter: [RPCDocs.Records.GetRecordTagsList.v1.TypeFilter.Vehicle],
						name: "vehicle.tags",
						isClearable: true,
						combineSelected: true,
						returnValueMode: "value",
						multi: true,
						placeholder: "Tags"
					})
				}),
				/* @__PURE__ */ jsx("div", {
					className: "col-span-2",
					children: /* @__PURE__ */ jsx(FormikSelect, {
						allowCreate: true,
						isClearable: true,
						name: "vehicle.type",
						options: toOptions(config?.vehicle.type),
						placeholder: "Type"
					})
				}),
				/* @__PURE__ */ jsx("div", {
					className: "col-span-2",
					children: /* @__PURE__ */ jsxs("div", {
						className: "gap-x-xxs bg-input-background inline-flex w-full items-center justify-center",
						children: [
							/* @__PURE__ */ jsx(FormikNumber, {
								name: "vehicle.yearFrom",
								placeholder: "Min Year"
							}),
							/* @__PURE__ */ jsx("div", {
								className: "px-xxs my-auto",
								children: /* @__PURE__ */ jsx(Icon, {
									color: "subtle",
									Icon: TbArrowBigRightFilled
								})
							}),
							/* @__PURE__ */ jsx(FormikNumber, {
								name: "vehicle.yearTo",
								placeholder: "Max Year"
							})
						]
					})
				}),
				/* @__PURE__ */ jsx("div", {
					className: "col-span-1",
					children: /* @__PURE__ */ jsx(FormikSelect, {
						allowCreate: true,
						name: "vehicle.color",
						options: toOptions(config?.vehicle.color),
						placeholder: "Colors"
					})
				})
			]
		})
	});
}
//#endregion
export { VehicleFields };

//# sourceMappingURL=VehicleFields.js.map